import { createContext } from 'react';

type InitialStateType = {
  isOpen: boolean;
};

type ContextType = {
  state: InitialStateType;
  dispatch: React.Dispatch<any>;
};

export const initialState = {
  isOpen: false,
};

const AccordionContext = createContext<ContextType>({
  state: initialState,
  dispatch: () => null,
});

export default AccordionContext;
